import React from "react";
import { Link } from "react-router-dom";
import * as ROUTES from "../constants/routes";

const IndexPage = () => {
    const pages = [
        { screen_id: "S1", name: "User Registration - ユーザー新規登録", path: "/sign-up" },
        { screen_id: "S2", name: "User Login - ユーザーログイン", path: "/sign-in" },
        { screen_id: "S5", name: "Dashboard - トップ", path: "/dashboard" }, 
        { screen_id: "S6", name: "Machine Input - 設備入力", path: "/machine-input" }, 
        { screen_id: "S7", name: "Register Inspection Result - 点検結果登録", path: "/register-inspection-result" }, 
        { screen_id: "S9", name: "Judgment - 承認", path: "/judgment" }, 
        { screen_id: "S12", name: "Search - 検索", path: "/search" }, 
        { screen_id: "S14", name: "Search Machine Master Result - 検索設備マスタ結果", path: "/search/machine-master" }, 
        { screen_id: "S15_1_1", name: "Search History Approval Result - 検索承認履歴結果", path: "/search/history-approval-result" }, 
        { screen_id: "S15_1_2", name: "Search Inspection History Confirmation - 検索履歴承認確認", path: "/search/search-inspection-history-confirm" }, 
        { screen_id: "S15_1_3", name: "Search Inspection History Edit - 検索履歴承認編集", path: "/search/search-inspection-history-edit" }, 
        { screen_id: "S15_2_1", name: "Search History Treatment Result - 検索処置履歴結果", path: "/search/history-treatment-result" }, 
        { screen_id: "S15_2_2", name: "Search History Treatment Detail - 検索処置履歴詳細", path: "/search/search-treatment-history-detail" }, 
        { screen_id: "S16", name: "Unfinished Action List - 処置未完リスト", path: "/unfinished-action-list" }, 
        { screen_id: "S17", name: "Treatment - 処置", path: "/treatment" }, 
        { screen_id: "S18", name: "My Page - マイページ", path: "/my-page" }, 
        { screen_id: "S19", name: "Settings - システム設定", path: "/settings" }, 
        { screen_id: "S20", name: "Template Management - 点検テンプレート編集", path: "/template-management" }, 
        { screen_id: "S21", name: "Edit Inspection Item - 点検項目編集", path: "/edit-inspection-item" }, 
        { screen_id: "S22", name: "Machine Master Top - 設備マスタトップ", path: "/machine-master" }, 
        { screen_id: "S23", name: "Machine Master Update - 設備マスタ更新", path: "/machine-master/update" }, 
        { screen_id: "S24", name: "Machine Master Update Import- 設備マスタインポート", path: "/machine-master/import" }, 
        { screen_id: "S25", name: "Machine Master Update Export- 設備マスタエクスポート", path: "/machine-master/export" }, 
        { screen_id: "S26", name: "Machine Master Update History Search- 設備マスタ更新履歴検索", path: "/machine-master/history-search" }, 
        { screen_id: "S27", name: "Machine Master Group Update- 設備マスタグループ更新", path: "/machine-master/group-update" }, 
        { screen_id: "S28", name: "department-update- 設備マスタグループ更新", path: ROUTES.DEPARTMENT_MASTER_UPDATE }, 
        { screen_id: "T1", name: "Approval Settings Management List - 承認設定管理リスト", path: "/approval-settings" }, 
        { screen_id: "T2", name: "Approval Settings Management Update - 承認設定管理更新", path: "/approval-settings/update" }, 
        { screen_id: "W1", name: "User Master Top - ユーザーマスタトップ", path: "/users/dashboard" }, 
        { screen_id: "W3", name: "User Master Update - ユーザーマスタ更新", path: "/users/update" },
        { screen_id: "W4", name: "User Master Import - ユーザーマスタインポート", path: "/users/import" },
        { screen_id: "W5", name: "User Master Update History Search - ユーザーマスタ更新履歴検索", path: "/users/update-history-search" },
        { screen_id: "W6", name: "User Master Search - ユーザーマスタ検索", path: "/users/search" },
        { screen_id: "W7", name: "User Master Position Manager - ユーザーマスタ職位管理", path: "/user-master/position" },
        { screen_id: "E404", name: "Error 404 - Not Found Page", path: "/error-404" },
    ];

    return (
        <div>
            <h1 className="text-center text-lg font-bol mb-[10px]">The List Pages</h1>
            <div className="flex justify-center">
                <table className="border-collapse border border-gray-400">
                    <thead>
                        <tr>
                            <th className="border border-gray-400 p-2 text-center">#</th>
                            <th className="border border-gray-400 p-2 text-center">Screen ID</th>
                            <th className="border border-gray-400 p-2">Screen Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pages.map((page, index) => (
                            <tr key={index}>
                                <td className="border border-gray-400 p-2 text-center">{index + 1}</td>
                                <td className="border border-gray-400 p-2 text-center">{page.screen_id}</td>
                                <td className="border border-gray-400 p-2"><Link to={page.path} className="text-blue-500">{page.name}</Link></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default IndexPage;